"use client";
export const dynamic = "force-dynamic";

import { Error } from "@repo/common/client/pages";
//console.log("Error component loaded");
export default Error;
